export const isSEB = () => {
  return navigator.userAgent.includes("SEB");
};
